import React, { FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { MessageBox, MessageBoxProps } from '../MessageBox/MessageBox';
import styles from './MessageListBox.module.css';

export type MessageListBoxProps = MessageBoxProps;

export const MessageListBox: FunctionComponent<MessageListBoxProps> =
  React.memo((props) => {
    const { children, ...remainingProps } = prepareProps({ props });

    return (
      <MessageBox {...remainingProps}>
        <ul className={styles.list}>{children}</ul>
      </MessageBox>
    );
  });
